import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: theme.component.borderMust,
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(1.5),
      paddingTop: theme.spacing(1.5),
    },
  },
  // icon: {
  // 	color: theme.palette.text.tertiary,
  // 	display: 'flex',
  // 	alignContent: 'center',
  // 	marginRight: -8,
  // 	[theme.breakpoints.down('sm')]: {
  // 		marginRight: theme.spacing(2),
  // 	}
  // },
  gridTitle: {
    display: 'flex',
  },
  gridTitleMargin: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  icon: {
    marginRight: theme.spacing(1.5),
  },
}));

function SettingsRow(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { primary, secondary, children, noWrap, icon, gutterBottom } = props;

  const upSm = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <div className={clsx(classes.root, gutterBottom && classes.gutterBottom)}>
      <Grid
        alignItems="center"
        className={classes.gridContainer}
        container
        spacing={upSm ? 3 : 0}
      >
        <Grid
          className={clsx(
            classes.gridTitle,
            !noWrap && classes.gridTitleMargin
          )}
          item
          xs={noWrap ? true : 12}
          md={4}
        >
          {icon && <span className={classes.icon}>{icon}</span>}
          <span>
            <Typography>{primary}</Typography>
            <Typography variant="caption">{secondary}</Typography>
          </span>
        </Grid>
        <Grid item xs={noWrap ? true : 12}>
          {children}
        </Grid>
      </Grid>
    </div>
  );
}

SettingsRow.propTypes = {
  children: PropTypes.node,
  gutterBottom: PropTypes.bool,
  icon: PropTypes.node,
  noWrap: PropTypes.bool,
  primary: PropTypes.node,
  secondary: PropTypes.node,
};

export default SettingsRow;
